import { CircularProgress } from '@mui/material';

interface Props {
  size?: number;
}

export default function SubmittingLoader(props: Props) {
  const halfSize = props.size ? props.size / 2 : 0;
  return (
    <CircularProgress
      size={props.size ? props.size : 28}
      style={{
        color: 'orange',
        position: 'absolute',
        left: props.size ? `calc(50% - ${halfSize})` : 'calc(50% - 14px)',
        top: props.size ? `calc(50% - ${halfSize})` : 'calc(50% - 14px)'
      }}
    />
  );
}
